export default __webpack_public_path__ + "static/tour-example4-c02c1c66e435c60f15609b218f16a040.png";